import styled from "styled-components";
const StyledHeader = styled.div`
  overflow-x: hidden;

  & .navbar {
    background: transparent;
    z-index: 999;
    top: 0;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.3s ease-in, background 0.3s ease-in;
    position: fixed;
    width: 100%;
    transform: translateY(0%);
    padding: 0.5rem 0;
    overflow: visible;
  }
  & .nav-slide {
    transform: translateY(-100%);
  }
  & .navbar.active {
    background: #072853 !important;
    padding: 0.5rem 0 0.25rem 0;
  }

  & .navbar-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
  }

  & .center-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 1;
    min-width: 0;
  }

  & .sunwest-logo {
    position: relative;
    width: auto;
    height: 27px;
    transform: translateX(-0.5rem);
  }
  & .angelai-logo {
    position: relative;
    width: auto;
    height: 43px;
    margin-right: 1.5rem;
    transform: translateX(0.25rem);
  }
  & .container-xl {
    padding-inline: 0rem;
  }
  & .desktop-show-Accessibility {
    position: relative;
    z-index: 10;
  }

  & .angelai-link {
    position: relative;
  }
  & .rigved-box {
    height: 1.25rem;
    width: calc(100% - 2rem);
    position: absolute;
    bottom: -0.25rem;
    right: 0;
    transform: translateX(0.35rem);
    cursor: pointer;
    color: #fff;
    font-size: 0.38rem;
    z-index: 1;
  }

  & .rigved-box + .pop-up {
    opacity: 0;
    height: 0;
    position: absolute;
    top: 3.5rem;
    right: -0.5rem;
    pointer-events: none;
    overflow: hidden;
  }

  & .rigved-box:where(:hover) + .pop-up {
    opacity: 1;
    height: 6rem;
    pointer-events: all;
    transition: 0.2s opacity ease-in, 0.2s height ease-in;
  }
  
  @media only screen and (max-width: 575px) {
    & .nav-slide .rigved-box + .pop-up,
    & .nav-slide .rigved-box:where(:hover) + .pop-up {
      opacity: 0;
      height: 0;
      pointer-events: none;
    }
  }
  @media only screen and (min-width: 320px) {
    & .sunwest-logo {
      height: 28px;
    }
    & .angelai-logo {
      height: 44px;
      margin-right: 2rem;
    }
    & .rigved-box{
      font-size: 0.42rem;
      bottom: -0.65rem;
      right: -0.5rem;
    }
  }
  @media only screen and (min-width: 340px) {
    & .sunwest-logo {
      height: 33px;
    }
    & .angelai-logo {
      height: 48px;
      margin-right: 2.5rem;
    }
    & .rigved-box + .pop-up {
    right: 0rem;
    }
    & .rigved-box{
      font-size: 0.45rem;
      bottom: -0.65rem;
      right: -0.5rem;
    }
  }
  @media only screen and (min-width: 375px) {
    & .sunwest-logo {
      height: 35px;
    }
    & .angelai-logo {
      height: 50px;
      margin-right: 2.75rem;
    }
    & .rigved-box{
      font-size: 0.46rem;
      bottom: -0.45rem;
      right: -0.75rem;
    }
  }
  @media only screen and (min-width: 400px) {
    & .sunwest-logo {
      height: 38px;
    }
    & .angelai-logo {
      height: 54px;
      margin-right: 3rem;
    }
    & .rigved-box{
      font-size: 0.48rem;
      bottom: -0.45rem;
      right: -1rem;
    }
  }
  @media only screen and (min-width: 450px) {
    & .container-xl {
      padding-inline: 1rem;
    }
    & .sunwest-logo {
      width: auto;
      height: 38px;
      transform: none;
    }
    & .angelai-logo {
      height: 55px;
      margin-right: 2.5rem;
      transform: none;
    }
    & .rigved-box{
      font-size: 0.5rem;
      bottom: -0.55rem;
      right: -0.5rem;
    }
  }
  @media only screen and (min-width: 576px) {
    & .rigved-box + .pop-up {
      top: 4rem;
      right: -2rem;
    }
    & .mobile-show-Accessibility {
      display: none;
    }
    & .sunwest-logo {
      height: 35px;
    }
    & .angelai-logo {
      height: 55px;
      margin-right: 2.5rem;
    }
    & .desktop-show-Accessibility {
      margin-left: -0.75rem;
    }
    & .rigved-box{
      font-size: 0.47rem;
        bottom: -0.45rem;
        right: -1.5rem;
    }
  }
  @media only screen and (min-width: 768px) {
    & .sunwest-logo {
      height: 40px;
    }
    & .angelai-logo {
      height: 60px;
      margin-right: 3rem;
    }
    & .desktop-show-Accessibility {
      margin-left: -0.5rem;
    }
    & .rigved-box{
      font-size: 0.52rem;
      bottom: -0.4rem;
      right: -1.25rem;
    }
  }
  @media only screen and (min-width: 992px) {
    & .desktop-show {
      transform: none;
    }
    & .rigved-box + .pop-up {
      top: 5rem;
    }
    //desktop
    & .sunwest-logo {
      width: auto;
      height: 42px;
    }
    & .angelai-logo {
      width: auto;
      height: 65px;
    }
    & .rigved-box {
      height: 1.5rem;
      width: calc(100% - 3.5rem);
      font-size: 0.58rem;
      right: 0px;
    }
  }
  @media only screen and (min-width: 1200px) {
    & .container-xl {
      padding-inline: 0rem;
    }
  }
  @media only screen and (max-width: 575px) {
    & .desktop-show-Accessibility {
      display: none;
    }
    & .mobile-show-Accessibility {
      position: absolute;
      right: 0.25rem;
      top: -1rem;
      z-index: 1000;
      transform: scale(0.85);
      pointer-events: auto;
    }
  }
  @media only screen and (max-width: 320px) {
    & .mobile-show-Accessibility {
      right: 0.15rem;
      top: -0.7rem;
      transform: scale(0.7);
    }
  }
`;

export default StyledHeader;
